import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { sircapApi } from "shared/api/sircap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useStore } from "zustand";
import { sessionModel } from "entities/session";
import { ContentType } from "shared/api/http-client";
import { blobToFile } from "helpers/functions";
import { DocumentType } from "static/types";
import "./style.scss";
import { accountStore } from "entities/account";
import TakePhotoModal from "../components/take-photo-modal";
import SubmitPhotoModal from "../components/submit-photo-modal";
import Selfie from "../../../../assets/verification/Selfie.svg";
import OpenCameraButton from "widgets/open-camera-btn";

enum ModalStep {
  Zero,
  Photo,
  Submit,
}

export const SelfieWithDocumentPage = () => {
  const [step, setStep] = useState<ModalStep>(ModalStep.Zero);
  const [image, setImage] = useState<any>();
  const { synckyc } = useStore(accountStore);
  const { t: err } = useTranslation("errors");
  const { t } = useTranslation("onboarding-auth");
  const { t: o } = useTranslation("onboarding");
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmit, setIsSubmit] = useState(false);

  const { setLink } = useStore(sessionModel.sessionStore);

  // Get country from navigation state and console log it
  // useEffect(() => {
  //   const country = location.state?.country;
  //   console.log("Selfie With Document - Country:", country);
  // }, [location.state]);

  useEffect(() => {
    setLink(PATH_LIST.proofOfAddress);

    return () => setLink("");
  }, []);

  const onOpen = () => {
    setStep(ModalStep.Photo);
  };

  const onSubmit = async () => {
    setIsSubmit(true);

    try {
      const livenessCheck = await sircapApi.onboarding.checkDocument(
        {
          type: "LIVENESS",
          fiz: blobToFile(image, `SELFIE.jpg`),
        },
        { type: ContentType.FormData }
      );

      if (livenessCheck.error) {
        toast.error(err(String(livenessCheck.error.code)));
        setIsSubmit(false);
        return;
      }

      // Check if liveness check failed
      if (livenessCheck.data?.data?.result === "FAILED") {
        toast.error(
          "Selfie verification failed — the photo may be unclear, the document is missing, or the face does not match the document."
        );
        setIsSubmit(false);
        setStep(ModalStep.Photo);
        return;
      }

      // liveness pass
      const resp = await sircapApi.onboarding.document(
        {
          country: "",
          citizenship: location.state?.citizenship,
          idDocType: "SELFIE",
          fiz: blobToFile(image, `SELFIE.jpg`),
        },
        { type: ContentType.FormData }
      );

      if (resp.error) {
        toast.error(err(String(resp.error.code)));
      } else {
        const kyc = resp.data.data;
        synckyc(kyc);

        // if (kyc.is_armenia_resident) {
        //   firebaseLogEvent("kyc_submitted");
        //   navigate(PATH_LIST.account, {
        //     state: { verificationRequestModal: true },
        //   });
        // } else {
        navigate(PATH_LIST.uploadCredentials);
        // }
      }
    } catch (error) {
      console.error("Error during selfie submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <>
      <div className="verification-selfie">
        <div className="verification-selfie-top">
          <img src={Selfie} alt="PhoneNumber" />
          {/* <p className="register-title">{t("selfieWithPassportID")}</p> */}
          <p className="register-title">
            {o("onePhotoFaceAndID")}
            <br />
            {o("onePhotoFaceAndID2")} <br />
            {o("onePhotoFaceAndID3")}
          </p>
          <span className="register-subtitle">
            {t("focusCameraFacePassportID")}
          </span>
        </div>
        {/* <VerificationBtn onClick={onOpen} text={t("takeSelfie")} /> */}
        <OpenCameraButton onOpen={onOpen} text={t("takeSelfie")} />
      </div>

      {step === ModalStep.Photo && (
        <TakePhotoModal
          type={DocumentType.Selfie}
          onOpen={(image: any) => {
            setImage(image);
            setStep(ModalStep.Submit);
          }}
          onClose={() => {
            setStep(ModalStep.Zero);
          }}
        />
      )}

      {step === ModalStep.Submit && (
        <SubmitPhotoModal
          type={DocumentType.Selfie}
          onSubmit={onSubmit}
          image={image}
          onClose={() => setStep(ModalStep.Photo)}
          isSubmit={isSubmit}
        />
      )}
    </>
  );
};
